import React, { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';
// Auth & utility pages
const AuthPage = lazy(() => import('../pages/AuthPage').then(m => ({
  default: m.AuthPage
})));
const AuthCallbackPage = lazy(() => import('../pages/AuthCallbackPage').then(m => ({
  default: m.AuthCallbackPage
})));
const LoadingPage = lazy(() => import('../pages/LoadingPage').then(m => ({
  default: m.LoadingPage
})));
const PaymentCallbackPage = lazy(() => import('../pages/PaymentCallbackPage').then(m => ({
  default: m.PaymentCallbackPage
})));
const PaymentSuccessPage = lazy(() => import('../pages/PaymentSuccessPage').then(m => ({
  default: m.PaymentSuccessPage
})));
const PublicResultsPage = lazy(() => import('../pages/PublicResultsPage').then(m => ({
  default: m.PublicResultsPage
})));
const GoogleAuthTestPage = lazy(() => import('../pages/GoogleAuthTestPage').then(m => ({
  default: m.GoogleAuthTestPage
})));
const DebugPage = lazy(() => import('../pages/DebugPage').then(m => ({
  default: m.DebugPage
})));
// Static content pages (React versions for preview)
const AboutPage = lazy(() => import('../pages/AboutPage').then(m => ({
  default: m.AboutPage
})));
const PrivacyPolicyPage = lazy(() => import('../pages/PrivacyPolicyPage').then(m => ({
  default: m.PrivacyPolicyPage
})));
const TermsOfServicePage = lazy(() => import('../pages/TermsOfServicePage').then(m => ({
  default: m.TermsOfServicePage
})));
const BlogIndexPage = lazy(() => import('../pages/BlogIndexPage').then(m => ({
  default: m.BlogIndexPage
})));
const StaticHtmlPage = lazy(() => import('../pages/StaticHtmlPage').then(m => ({
  default: m.StaticHtmlPage
})));
// EN blog posts (with JSON data)
const BlogPost7SignsGaslighting = lazy(() => import('../pages/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslighting
})));
const BlogPostCovertNarcissist = lazy(() => import('../pages/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissist
})));
const BlogPostPassiveAggressiveTexts = lazy(() => import('../pages/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTexts
})));
const BlogPostNarcissismGaslighting = lazy(() => import('../pages/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslighting
})));
const BlogPostEmotionalDrain = lazy(() => import('../pages/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrain
})));
const BlogPostEmotionalDrainPart2 = lazy(() => import('../pages/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2
})));
// Language landing pages
const LandingPageDE = lazy(() => import('../pages/lang/de/LandingPage').then(m => ({
  default: m.LandingPageDE
})));
const LandingPageES = lazy(() => import('../pages/lang/es/LandingPage').then(m => ({
  default: m.LandingPageES
})));
const LandingPageFR = lazy(() => import('../pages/lang/fr/LandingPage').then(m => ({
  default: m.LandingPageFR
})));
const LandingPageHI = lazy(() => import('../pages/lang/hi/LandingPage').then(m => ({
  default: m.LandingPageHI
})));
const LandingPageID = lazy(() => import('../pages/lang/id/LandingPage').then(m => ({
  default: m.LandingPageID
})));
const LandingPageJA = lazy(() => import('../pages/lang/ja/LandingPage').then(m => ({
  default: m.LandingPageJA
})));
const LandingPageKO = lazy(() => import('../pages/lang/ko/LandingPage').then(m => ({
  default: m.LandingPageKO
})));
const LandingPagePT = lazy(() => import('../pages/lang/pt/LandingPage').then(m => ({
  default: m.LandingPagePT
})));
// DE blog posts
const BlogPost7SignsGaslightingDE = lazy(() => import('../pages/lang/de/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingDE
})));
const BlogPostCovertNarcissistDE = lazy(() => import('../pages/lang/de/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistDE
})));
const BlogPostEmotionalDrainDE = lazy(() => import('../pages/lang/de/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainDE
})));
const BlogPostEmotionalDrainPart2DE = lazy(() => import('../pages/lang/de/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2DE
})));
const BlogPostNarcissismGaslightingDE = lazy(() => import('../pages/lang/de/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingDE
})));
const BlogPostPassiveAggressiveTextsDE = lazy(() => import('../pages/lang/de/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsDE
})));
// ES blog posts
const BlogPost7SignsGaslightingES = lazy(() => import('../pages/lang/es/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingES
})));
const BlogPostCovertNarcissistES = lazy(() => import('../pages/lang/es/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistES
})));
const BlogPostEmotionalDrainES = lazy(() => import('../pages/lang/es/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainES
})));
const BlogPostEmotionalDrainPart2ES = lazy(() => import('../pages/lang/es/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2ES
})));
const BlogPostNarcissismGaslightingES = lazy(() => import('../pages/lang/es/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingES
})));
const BlogPostPassiveAggressiveTextsES = lazy(() => import('../pages/lang/es/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsES
})));
// FR blog posts
const BlogPost7SignsGaslightingFR = lazy(() => import('../pages/lang/fr/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingFR
})));
const BlogPostCovertNarcissistFR = lazy(() => import('../pages/lang/fr/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistFR
})));
const BlogPostEmotionalDrainFR = lazy(() => import('../pages/lang/fr/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainFR
})));
const BlogPostEmotionalDrainPart2FR = lazy(() => import('../pages/lang/fr/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2FR
})));
const BlogPostNarcissismGaslightingFR = lazy(() => import('../pages/lang/fr/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingFR
})));
const BlogPostPassiveAggressiveTextsFR = lazy(() => import('../pages/lang/fr/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsFR
})));
// HI blog posts
const BlogPost7SignsGaslightingHI = lazy(() => import('../pages/lang/hi/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingHI
})));
const BlogPostCovertNarcissistHI = lazy(() => import('../pages/lang/hi/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistHI
})));
const BlogPostEmotionalDrainHI = lazy(() => import('../pages/lang/hi/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainHI
})));
const BlogPostEmotionalDrainPart2HI = lazy(() => import('../pages/lang/hi/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2HI
})));
const BlogPostNarcissismGaslightingHI = lazy(() => import('../pages/lang/hi/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingHI
})));
const BlogPostPassiveAggressiveTextsHI = lazy(() => import('../pages/lang/hi/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsHI
})));
// ID blog posts
const BlogPost7SignsGaslightingID = lazy(() => import('../pages/lang/id/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingID
})));
const BlogPostCovertNarcissistID = lazy(() => import('../pages/lang/id/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistID
})));
const BlogPostEmotionalDrainID = lazy(() => import('../pages/lang/id/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainID
})));
const BlogPostEmotionalDrainPart2ID = lazy(() => import('../pages/lang/id/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2ID
})));
const BlogPostNarcissismGaslightingID = lazy(() => import('../pages/lang/id/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingID
})));
const BlogPostPassiveAggressiveTextsID = lazy(() => import('../pages/lang/id/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsID
})));
// JA blog posts
const BlogPost7SignsGaslightingJA = lazy(() => import('../pages/lang/ja/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingJA
})));
const BlogPostCovertNarcissistJA = lazy(() => import('../pages/lang/ja/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistJA
})));
const BlogPostEmotionalDrainJA = lazy(() => import('../pages/lang/ja/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainJA
})));
const BlogPostEmotionalDrainPart2JA = lazy(() => import('../pages/lang/ja/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2JA
})));
const BlogPostNarcissismGaslightingJA = lazy(() => import('../pages/lang/ja/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingJA
})));
const BlogPostPassiveAggressiveTextsJA = lazy(() => import('../pages/lang/ja/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsJA
})));
// KO blog posts
const BlogPost7SignsGaslightingKO = lazy(() => import('../pages/lang/ko/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingKO
})));
const BlogPostCovertNarcissistKO = lazy(() => import('../pages/lang/ko/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistKO
})));
const BlogPostEmotionalDrainKO = lazy(() => import('../pages/lang/ko/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainKO
})));
const BlogPostEmotionalDrainPart2KO = lazy(() => import('../pages/lang/ko/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2KO
})));
const BlogPostNarcissismGaslightingKO = lazy(() => import('../pages/lang/ko/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingKO
})));
const BlogPostPassiveAggressiveTextsKO = lazy(() => import('../pages/lang/ko/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsKO
})));
// PT blog posts
const BlogPost7SignsGaslightingPT = lazy(() => import('../pages/lang/pt/blog/BlogPost7SignsGaslighting').then(m => ({
  default: m.BlogPost7SignsGaslightingPT
})));
const BlogPostCovertNarcissistPT = lazy(() => import('../pages/lang/pt/blog/BlogPostCovertNarcissist').then(m => ({
  default: m.BlogPostCovertNarcissistPT
})));
const BlogPostEmotionalDrainPT = lazy(() => import('../pages/lang/pt/blog/BlogPostEmotionalDrain').then(m => ({
  default: m.BlogPostEmotionalDrainPT
})));
const BlogPostEmotionalDrainPart2PT = lazy(() => import('../pages/lang/pt/blog/BlogPostEmotionalDrainPart2').then(m => ({
  default: m.BlogPostEmotionalDrainPart2PT
})));
const BlogPostNarcissismGaslightingPT = lazy(() => import('../pages/lang/pt/blog/BlogPostNarcissismGaslighting').then(m => ({
  default: m.BlogPostNarcissismGaslightingPT
})));
const BlogPostPassiveAggressiveTextsPT = lazy(() => import('../pages/lang/pt/blog/BlogPostPassiveAggressiveTexts').then(m => ({
  default: m.BlogPostPassiveAggressiveTextsPT
})));
export const mainRoutes = <Fragment data-id="element-10624">
    {/* Auth & utility routes */}
    <Route path="/signup" element={<AuthPage data-id="element-10626" />} data-id="element-10625" />
    <Route path="/login" element={<AuthPage data-id="element-10628" />} data-id="element-10627" />
    <Route path="/auth/callback" element={<AuthCallbackPage data-id="element-10630" />} data-id="element-10629" />
    <Route path="/payment-callback" element={<PaymentCallbackPage data-id="element-10632" />} data-id="element-10631" />
    <Route path="/payment-success" element={<PaymentSuccessPage data-id="element-10634" />} data-id="element-10633" />
    <Route path="/loading" element={<LoadingPage data-id="element-10636" />} data-id="element-10635" />
    <Route path="/results" element={<PublicResultsPage data-id="element-10638" />} data-id="element-10637" />
    <Route path="/test-google" element={<GoogleAuthTestPage data-id="element-10640" />} data-id="element-10639" />
    <Route path="/debug" element={<DebugPage data-id="element-10642" />} data-id="element-10641" />

    {/* Static content pages (React versions for preview) */}
    <Route path="/about" element={<AboutPage data-id="element-10644" />} data-id="element-10643" />
    <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-10646" />} data-id="element-10645" />
    <Route path="/terms" element={<TermsOfServicePage data-id="element-10648" />} data-id="element-10647" />
    <Route path="/blog" element={<BlogIndexPage data-id="element-10650" />} data-id="element-10649" />
    <Route path="/faq" element={<StaticHtmlPage data-id="element-10652" />} data-id="element-10651" />

    {/* EN blog posts with full React components */}
    <Route path="/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslighting data-id="element-10654" />} data-id="element-10653" />
    <Route path="/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissist data-id="element-10656" />} data-id="element-10655" />
    <Route path="/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTexts data-id="element-10658" />} data-id="element-10657" />
    <Route path="/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslighting data-id="element-10660" />} data-id="element-10659" />
    <Route path="/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrain data-id="element-10662" />} data-id="element-10661" />
    <Route path="/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2 data-id="element-10664" />} data-id="element-10663" />

    {/* Remaining EN blog posts — rendered from static HTML */}
    <Route path="/blog/how-to-respond-to-manipulation" element={<StaticHtmlPage data-id="element-10666" />} data-id="element-10665" />
    <Route path="/blog/signs-of-emotional-manipulation" element={<StaticHtmlPage data-id="element-10668" />} data-id="element-10667" />
    <Route path="/blog/how-to-set-boundaries-with-toxic-people" element={<StaticHtmlPage data-id="element-10670" />} data-id="element-10669" />
    <Route path="/blog/trauma-bonding-explained" element={<StaticHtmlPage data-id="element-10672" />} data-id="element-10671" />
    <Route path="/blog/digital-abuse-in-relationships" element={<StaticHtmlPage data-id="element-10674" />} data-id="element-10673" />
    <Route path="/blog/love-bombing-red-flags" element={<StaticHtmlPage data-id="element-10676" />} data-id="element-10675" />
    <Route path="/blog/stonewalling-in-relationships" element={<StaticHtmlPage data-id="element-10678" />} data-id="element-10677" />
    <Route path="/blog/toxic-workplace-messages" element={<StaticHtmlPage data-id="element-10680" />} data-id="element-10679" />
    <Route path="/blog/gaslighting-phrases-to-watch-for" element={<StaticHtmlPage data-id="element-10682" />} data-id="element-10681" />
    <Route path="/blog/toxic-friendship-signs" element={<StaticHtmlPage data-id="element-10684" />} data-id="element-10683" />
    <Route path="/blog/how-ai-detects-toxic-messages" element={<StaticHtmlPage data-id="element-10686" />} data-id="element-10685" />
    <Route path="/blog/narcissist-text-patterns" element={<StaticHtmlPage data-id="element-10688" />} data-id="element-10687" />
    <Route path="/blog/emotional-abuse-vs-normal-conflict" element={<StaticHtmlPage data-id="element-10690" />} data-id="element-10689" />
    <Route path="/blog/healing-after-toxic-relationship" element={<StaticHtmlPage data-id="element-10692" />} data-id="element-10691" />
    <Route path="/blog/controlling-behavior-in-texts" element={<StaticHtmlPage data-id="element-10694" />} data-id="element-10693" />
    <Route path="/blog/what-is-darvo" element={<StaticHtmlPage data-id="element-10696" />} data-id="element-10695" />
    <Route path="/blog/silent-treatment-manipulation" element={<StaticHtmlPage data-id="element-10698" />} data-id="element-10697" />
    <Route path="/blog/guilt-tripping-in-relationships" element={<StaticHtmlPage data-id="element-10700" />} data-id="element-10699" />
    <Route path="/blog/toxic-relationship-quiz-questions" element={<StaticHtmlPage data-id="element-10702" />} data-id="element-10701" />
    <Route path="/blog/breadcrumbing-in-dating" element={<StaticHtmlPage data-id="element-10704" />} data-id="element-10703" />
    <Route path="/blog/ghosting-vs-healthy-boundaries" element={<StaticHtmlPage data-id="element-10706" />} data-id="element-10705" />
    <Route path="/blog/emotional-intelligence-in-relationships" element={<StaticHtmlPage data-id="element-10708" />} data-id="element-10707" />
    <Route path="/blog/toxic-parents-text-messages" element={<StaticHtmlPage data-id="element-10710" />} data-id="element-10709" />
    <Route path="/blog/recognizing-coercive-control" element={<StaticHtmlPage data-id="element-10712" />} data-id="element-10711" />
    <Route path="/blog/healthy-vs-toxic-communication" element={<StaticHtmlPage data-id="element-10714" />} data-id="element-10713" />
    <Route path="/blog/why-you-attract-toxic-people" element={<StaticHtmlPage data-id="element-10716" />} data-id="element-10715" />
    <Route path="/blog/manipulation-in-long-distance-relationships" element={<StaticHtmlPage data-id="element-10718" />} data-id="element-10717" />
    <Route path="/blog/self-gaslighting" element={<StaticHtmlPage data-id="element-10720" />} data-id="element-10719" />
    <Route path="/blog/toxic-positivity-in-relationships" element={<StaticHtmlPage data-id="element-10722" />} data-id="element-10721" />
    <Route path="/blog/financial-abuse-warning-signs" element={<StaticHtmlPage data-id="element-10724" />} data-id="element-10723" />
    <Route path="/blog/how-to-leave-toxic-relationship-safely" element={<StaticHtmlPage data-id="element-10726" />} data-id="element-10725" />
    <Route path="/blog/intermittent-reinforcement-relationships" element={<StaticHtmlPage data-id="element-10728" />} data-id="element-10727" />
    <Route path="/blog/projection-in-toxic-relationships" element={<StaticHtmlPage data-id="element-10730" />} data-id="element-10729" />
    <Route path="/blog/emotional-flooding-during-arguments" element={<StaticHtmlPage data-id="element-10732" />} data-id="element-10731" />
    <Route path="/blog/triangulation-manipulation-tactic" element={<StaticHtmlPage data-id="element-10734" />} data-id="element-10733" />
    <Route path="/blog/signs-youre-in-denial-about-toxic-relationship" element={<StaticHtmlPage data-id="element-10736" />} data-id="element-10735" />
    <Route path="/blog/how-toxic-people-use-social-media" element={<StaticHtmlPage data-id="element-10738" />} data-id="element-10737" />
    <Route path="/blog/double-bind-communication" element={<StaticHtmlPage data-id="element-10740" />} data-id="element-10739" />
    <Route path="/blog/recovering-self-esteem-after-abuse" element={<StaticHtmlPage data-id="element-10742" />} data-id="element-10741" />
    <Route path="/blog/weaponized-incompetence" element={<StaticHtmlPage data-id="element-10744" />} data-id="element-10743" />
    <Route path="/blog/anxiety-in-toxic-relationships" element={<StaticHtmlPage data-id="element-10746" />} data-id="element-10745" />
    <Route path="/blog/red-flags-first-date-texts" element={<StaticHtmlPage data-id="element-10748" />} data-id="element-10747" />
    <Route path="/blog/codependency-in-toxic-relationships" element={<StaticHtmlPage data-id="element-10750" />} data-id="element-10749" />
    <Route path="/blog/gaslighting-at-work" element={<StaticHtmlPage data-id="element-10752" />} data-id="element-10751" />
    <Route path="/blog/emotional-blackmail-tactics" element={<StaticHtmlPage data-id="element-10754" />} data-id="element-10753" />
    <Route path="/blog/future-faking-manipulation" element={<StaticHtmlPage data-id="element-10756" />} data-id="element-10755" />
    <Route path="/blog/hoovering-after-breakup" element={<StaticHtmlPage data-id="element-10758" />} data-id="element-10757" />
    <Route path="/blog/toxic-relationship-effect-on-children" element={<StaticHtmlPage data-id="element-10760" />} data-id="element-10759" />
    <Route path="/blog/ai-relationship-analysis-guide" element={<StaticHtmlPage data-id="element-10762" />} data-id="element-10761" />
    <Route path="/blog/types-of-toxic-relationships" element={<StaticHtmlPage data-id="element-10764" />} data-id="element-10763" />
    <Route path="/blog/mental-health-apps-for-toxic-relationships" element={<StaticHtmlPage data-id="element-10766" />} data-id="element-10765" />

    {/* ===== LANGUAGE LANDING PAGES ===== */}
    <Route path="/de" element={<LandingPageDE data-id="element-10768" />} data-id="element-10767" />
    <Route path="/es" element={<LandingPageES data-id="element-10770" />} data-id="element-10769" />
    <Route path="/fr" element={<LandingPageFR data-id="element-10772" />} data-id="element-10771" />
    <Route path="/hi" element={<LandingPageHI data-id="element-10774" />} data-id="element-10773" />
    <Route path="/id" element={<LandingPageID data-id="element-10776" />} data-id="element-10775" />
    <Route path="/ja" element={<LandingPageJA data-id="element-10778" />} data-id="element-10777" />
    <Route path="/ko" element={<LandingPageKO data-id="element-10780" />} data-id="element-10779" />
    <Route path="/pt" element={<LandingPagePT data-id="element-10782" />} data-id="element-10781" />

    {/* ===== DE blog posts ===== */}
    <Route path="/de/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingDE data-id="element-10784" />} data-id="element-10783" />
    <Route path="/de/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistDE data-id="element-10786" />} data-id="element-10785" />
    <Route path="/de/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsDE data-id="element-10788" />} data-id="element-10787" />
    <Route path="/de/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingDE data-id="element-10790" />} data-id="element-10789" />
    <Route path="/de/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainDE data-id="element-10792" />} data-id="element-10791" />
    <Route path="/de/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2DE data-id="element-10794" />} data-id="element-10793" />

    {/* ===== ES blog posts ===== */}
    <Route path="/es/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingES data-id="element-10796" />} data-id="element-10795" />
    <Route path="/es/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistES data-id="element-10798" />} data-id="element-10797" />
    <Route path="/es/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsES data-id="element-10800" />} data-id="element-10799" />
    <Route path="/es/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingES data-id="element-10802" />} data-id="element-10801" />
    <Route path="/es/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainES data-id="element-10804" />} data-id="element-10803" />
    <Route path="/es/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2ES data-id="element-10806" />} data-id="element-10805" />

    {/* ===== FR blog posts ===== */}
    <Route path="/fr/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingFR data-id="element-10808" />} data-id="element-10807" />
    <Route path="/fr/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistFR data-id="element-10810" />} data-id="element-10809" />
    <Route path="/fr/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsFR data-id="element-10812" />} data-id="element-10811" />
    <Route path="/fr/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingFR data-id="element-10814" />} data-id="element-10813" />
    <Route path="/fr/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainFR data-id="element-10816" />} data-id="element-10815" />
    <Route path="/fr/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2FR data-id="element-10818" />} data-id="element-10817" />

    {/* ===== HI blog posts ===== */}
    <Route path="/hi/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingHI data-id="element-10820" />} data-id="element-10819" />
    <Route path="/hi/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistHI data-id="element-10822" />} data-id="element-10821" />
    <Route path="/hi/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsHI data-id="element-10824" />} data-id="element-10823" />
    <Route path="/hi/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingHI data-id="element-10826" />} data-id="element-10825" />
    <Route path="/hi/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainHI data-id="element-10828" />} data-id="element-10827" />
    <Route path="/hi/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2HI data-id="element-10830" />} data-id="element-10829" />

    {/* ===== ID blog posts ===== */}
    <Route path="/id/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingID data-id="element-10832" />} data-id="element-10831" />
    <Route path="/id/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistID data-id="element-10834" />} data-id="element-10833" />
    <Route path="/id/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsID data-id="element-10836" />} data-id="element-10835" />
    <Route path="/id/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingID data-id="element-10838" />} data-id="element-10837" />
    <Route path="/id/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainID data-id="element-10840" />} data-id="element-10839" />
    <Route path="/id/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2ID data-id="element-10842" />} data-id="element-10841" />

    {/* ===== JA blog posts ===== */}
    <Route path="/ja/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingJA data-id="element-10844" />} data-id="element-10843" />
    <Route path="/ja/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistJA data-id="element-10846" />} data-id="element-10845" />
    <Route path="/ja/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsJA data-id="element-10848" />} data-id="element-10847" />
    <Route path="/ja/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingJA data-id="element-10850" />} data-id="element-10849" />
    <Route path="/ja/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainJA data-id="element-10852" />} data-id="element-10851" />
    <Route path="/ja/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2JA data-id="element-10854" />} data-id="element-10853" />

    {/* ===== KO blog posts ===== */}
    <Route path="/ko/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingKO data-id="element-10856" />} data-id="element-10855" />
    <Route path="/ko/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistKO data-id="element-10858" />} data-id="element-10857" />
    <Route path="/ko/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsKO data-id="element-10860" />} data-id="element-10859" />
    <Route path="/ko/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingKO data-id="element-10862" />} data-id="element-10861" />
    <Route path="/ko/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainKO data-id="element-10864" />} data-id="element-10863" />
    <Route path="/ko/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2KO data-id="element-10866" />} data-id="element-10865" />

    {/* ===== PT blog posts ===== */}
    <Route path="/pt/blog/7-signs-of-gaslighting" element={<BlogPost7SignsGaslightingPT data-id="element-10868" />} data-id="element-10867" />
    <Route path="/pt/blog/is-your-ex-covert-narcissist" element={<BlogPostCovertNarcissistPT data-id="element-10870" />} data-id="element-10869" />
    <Route path="/pt/blog/how-to-spot-passive-aggressive-texts" element={<BlogPostPassiveAggressiveTextsPT data-id="element-10872" />} data-id="element-10871" />
    <Route path="/pt/blog/narcissism-and-gaslighting-explained" element={<BlogPostNarcissismGaslightingPT data-id="element-10874" />} data-id="element-10873" />
    <Route path="/pt/blog/why-some-people-drain-you" element={<BlogPostEmotionalDrainPT data-id="element-10876" />} data-id="element-10875" />
    <Route path="/pt/blog/emotional-drain-part-2" element={<BlogPostEmotionalDrainPart2PT data-id="element-10878" />} data-id="element-10877" />
  </Fragment>;